/*
 * Location: assets/gelsome-logo-banner.js
 * What: ロゴバナー（コピー付き）で、ロゴ下のコピーをロゴと同じ動きにする。
 * Why: Wonder の page-header-logo-banner.js はロゴ画像だけを CSS transform で拡縮する
 *      （ページ最上部で最大、スクロールでヘッダーのロゴサイズまで縮む）。transform は
 *      兄弟要素を動かさないので、コピーを普通に置くとロゴとは別の動きになる。
 *      ここではロゴの実際の描画位置（getBoundingClientRect）と現在の倍率を読み、
 *      コピーをロゴの下端に同じ倍率で追従させる。テーマの JS は変更しない。
 * How: 倍率 f = 現在のロゴ倍率 / 最上部でのロゴ倍率（Wonder と同じ式で算出）。
 *      コピーは設定サイズで最上部に表示され、ロゴと同じ比率で縮む。
 *      更新はロゴの style 属性（transform）の変化・スクロール・リサイズで行い、rAF で間引く。
 * RELEVANT FILES: sections/gelsome-logo-banner.liquid, assets/page-header-logo-banner.js,
 *                 assets/section-logo-banner.css
 */
(function () {
  "use strict";

  function isMobile() {
    return window.matchMedia("(max-width: 899px)").matches;
  }

  /* Wonder の calculateMaxScale と同じ: ヘッダーの --logo-width-* を基準に、画面幅の60%まで、最大6倍 */
  function maxScaleFor(logo) {
    var header = document.querySelector(".wt-header");
    var nominal = 0;
    if (header) {
      var cs = window.getComputedStyle(header);
      nominal = parseInt(cs.getPropertyValue(isMobile() ? "--logo-width-mobile" : "--logo-width-desk"), 10);
    }
    if (!nominal || isNaN(nominal)) nominal = logo.offsetWidth || 1;
    var max = (window.innerWidth * 0.6) / nominal;
    return Math.max(1, Math.min(max, 6));
  }

  function currentScale(logo) {
    var m = /scale\(([\d.]+)\)/.exec(logo.style.transform || "");
    return m ? parseFloat(m[1]) : 1;
  }

  function init(root) {
    if (root.dataset.gsCopyReady) return;
    var copy = root.querySelector(".gs-logo-banner__copy");
    var logo = root.querySelector(".wt-logo-banner__logo");
    var layer = root.querySelector(".wt-logo-banner__picture");
    if (!logo || !layer) return;
    root.dataset.gsCopyReady = "1";

    var raf = 0;

    function gap() {
      var v = parseFloat(isMobile() ? copy.dataset.gap : copy.dataset.gapDesktop);
      return isNaN(v) ? 16 : v;
    }

    function update() {
      raf = 0;
      /* Keep the initial offset, then converge on Wonder's original endpoint. */
      var rect = root.getBoundingClientRect();
      var header = document.querySelector(".wt-header");
      var headerHeight = header ? header.offsetHeight : 0;
      var initialBottom = rect.bottom + window.scrollY;
      var travel = Math.max(1, initialBottom - headerHeight);
      var progress = Math.max(0, Math.min(1, (rect.bottom - headerHeight) / travel));
      root.style.setProperty("--gs-logo-position-progress", progress);
      if (!copy) return;
      var s = currentScale(logo);
      var f = Math.max(0, Math.min(1, s / maxScaleFor(logo)));
      var lr = logo.getBoundingClientRect();
      var pr = layer.getBoundingClientRect();
      if (!lr.width) return;
      /* ロゴの見かけ上の下端 + 余白（余白もロゴと一緒に縮む） */
      copy.style.top = lr.bottom - pr.top + gap() * f + "px";
      copy.style.transform = "translateX(-50%) scale(" + f + ")";
      copy.classList.add("is-placed");
    }

    function schedule() {
      if (!raf) raf = window.requestAnimationFrame(update);
    }

    /* Wonder がロゴの transform を書き換えた直後に追従する */
    new MutationObserver(schedule).observe(logo, { attributes: true, attributeFilter: ["style"] });
    document.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    window.addEventListener("load", schedule);
    if (logo.tagName === "IMG" && !logo.complete) logo.addEventListener("load", schedule);
    schedule();
  }

  function initAll() {
    document.querySelectorAll("page-header-logo-banner.gs-logo-banner").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  /* テーマエディタでセクションが再描画されたとき */
  document.addEventListener("shopify:section:load", initAll);
})();
